import React, { useState } from "react";
import '../index.css';

function Spoiler({ text, editable, clickable }) {
  const [visible, setVisible] = useState(editable);

  const onSpoilerClick = () => {
      if(!visible && clickable) {
          setVisible(true);
      }
  }

  return (
    <span
      onClick={onSpoilerClick}
      className={`spoiler ${
        (!visible && !editable) ? "bg-contain dark:bg-[url('img/spoiler-dots-white.png')] bg-[url('img/spoiler-dots-black.jpg')] bg-repeat animate-[pulse_1.75s_linear_infinite] cursor-pointer" : ""} ${
        (editable) ? "bg-[#E3E4E4] dark:bg-[#48576D]" : ""}`
      }
    >
      <span className={visible || editable ? "opacity-100" : "opacity-0 select-none"}>
        {text}
      </span>
    </span>
  );
}

export default Spoiler;
